import { render } from "./BlogCoverPreview.vue?vue&type=template&id=1148ae1d&scoped=true"
import script from "./BlogCoverPreview.vue?vue&type=script&lang=js"
export * from "./BlogCoverPreview.vue?vue&type=script&lang=js"

import "./BlogCoverPreview.vue?vue&type=style&index=0&id=1148ae1d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1148ae1d"]])

export default __exports__